export default function GoogleReviewQR() {
  const reviewUrl = 'https://g.page/r/igmfacilityservice/review';
  const qrUrl = `https://chart.googleapis.com/chart?cht=qr&chs=220x220&chl=${encodeURIComponent(reviewUrl)}&choe=UTF-8&chld=M|2`;

  return (
    <section className="py-16 sm:py-20 bg-white border-t border-gray-100">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section label */}
        <div className="flex items-center gap-2 mb-4 justify-center">
          <span className="w-8 h-[2px] bg-[#C8A96E]" />
          <span className="text-[#C8A96E] text-xs font-bold tracking-widest uppercase">Nach dem Auftrag</span>
          <span className="w-8 h-[2px] bg-[#C8A96E]" />
        </div>
        <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 text-center mb-3">
          Waren Sie zufrieden? Dann freuen wir uns über Ihre Bewertung!
        </h2>
        <p className="text-gray-500 text-sm sm:text-base text-center max-w-xl mx-auto mb-12">
          Einfach QR-Code scannen und direkt auf Google bewerten — dauert nur 60 Sekunden
          und hilft anderen Kunden in Ratingen &amp; NRW, uns zu finden.
        </p>

        <div className="grid md:grid-cols-2 gap-8 items-center">
          {/* Left — QR code card */}
          <div className="flex flex-col items-center">
            <div className="bg-[#F8F7F4] rounded-3xl p-8 flex flex-col items-center gap-5 border border-gray-200 relative">
              {/* Top label */}
              <div className="flex items-center gap-2">
                {['G','o','o','g','l','e'].map((l, i) => {
                  const colors = ['#4285F4','#EA4335','#FBBC05','#4285F4','#34A853','#EA4335'];
                  return (
                    <span key={i} className="font-black text-lg leading-none" style={{ color: colors[i] }}>{l}</span>
                  );
                })}
                <span className="text-gray-500 text-sm font-medium ml-1">Bewertung</span>
              </div>

              {/* QR Code */}
              <div className="bg-white p-3 rounded-2xl border border-gray-200">
                <img
                  src={qrUrl}
                  alt="QR-Code für Google Bewertung IGM Facility Service"
                  width={192}
                  height={192}
                  className="w-48 h-48 object-contain"
                />
              </div>

              {/* Scan hint */}
              <div className="flex items-center gap-2 bg-[#0D2B4E]/5 rounded-xl px-4 py-2.5 border border-[#0D2B4E]/10">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-qr-scan-2-line text-[#0D2B4E] text-base" />
                </div>
                <span className="text-[#0D2B4E] text-xs font-semibold">Kamera auf QR-Code richten &amp; scannen</span>
              </div>

              {/* 5 stars */}
              <div className="flex gap-1">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#FBBC04] text-xl" />
                ))}
              </div>

              {/* Badge */}
              <div className="absolute -top-3 -right-3 bg-[#34A853] text-white text-xs font-bold px-3 py-1 rounded-full whitespace-nowrap">
                ⭐ Jetzt bewerten
              </div>
            </div>
          </div>

          {/* Right — info + button */}
          <div className="flex flex-col gap-6">
            {/* Steps */}
            <div className="flex flex-col gap-4">
              {[
                {
                  num: '1',
                  icon: 'ri-smartphone-line',
                  title: 'Handy-Kamera öffnen',
                  desc: 'Keine App nötig — einfach die Standard-Kamera auf den QR-Code halten.',
                },
                {
                  num: '2',
                  icon: 'ri-star-line',
                  title: 'Sterne vergeben',
                  desc: 'Wählen Sie Ihre Bewertung und schreiben Sie optional einen kurzen Kommentar.',
                },
                {
                  num: '3',
                  icon: 'ri-send-plane-line',
                  title: 'Absenden — fertig!',
                  desc: 'Ihre Bewertung hilft uns und anderen Kunden in der Region Rhein-Ruhr.',
                },
              ].map((s) => (
                <div key={s.num} className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-[#0D2B4E] rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className={`${s.icon} text-white text-base`} />
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900 text-sm mb-0.5">{s.title}</p>
                    <p className="text-gray-500 text-xs leading-relaxed">{s.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* Divider */}
            <div className="flex items-center gap-3">
              <div className="flex-1 h-px bg-gray-200" />
              <span className="text-xs text-gray-400 whitespace-nowrap">oder direkt per Link</span>
              <div className="flex-1 h-px bg-gray-200" />
            </div>

            {/* CTA Button */}
            <a
              href={reviewUrl}
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="inline-flex items-center justify-center gap-3 bg-[#0D2B4E] text-white px-7 py-4 rounded-xl font-bold text-base hover:bg-[#0a2240] transition-all cursor-pointer whitespace-nowrap"
            >
              <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                <i className="ri-star-fill text-[#FBBC04] text-lg" />
              </div>
              Jetzt auf Google bewerten
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-right-line text-base" />
              </div>
            </a>

            {/* Trust note */}
            <div className="flex items-center gap-2">
              <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                <i className="ri-shield-check-line text-[#34A853] text-base" />
              </div>
              <span className="text-xs text-gray-400">Verifizierte Google-Bewertung · Keine App erforderlich · 100% kostenlos</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
